import { useState } from 'react';
import type { ConnectionWizardCommonProps } from '../connectionTypes';
import { __ } from '@/hub-shared/utils/i18n';
import { disconnectComptExpert } from '../utils/comptExpertConnection';

type ComptExpertTokenWizardProps = ConnectionWizardCommonProps & {
  connected: boolean;
};

const ComptExpertTokenWizard = ({
  restBasePath,
  nonce,
  apiBaseUrl,
  onClose,
  onConnectionUpdated,
  onSessionExpired,
  connected,
}: ComptExpertTokenWizardProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handlers = {
    apiBaseUrl,
    restBasePath,
    nonce,
    onSessionExpired,
    onSuccess: () => {
      onConnectionUpdated();
      onClose();
    },
    onError: setError,
  };

  const handleDisconnect = async () => {
    setIsSubmitting(true);
    setError('');
    await disconnectComptExpert(handlers);
    setIsSubmitting(false);
  };

  return (
    <section className="connection-wizard-body">
      <p>{__('Déconnecter JeSignExpert de ce cabinet.')}</p>
      {error !== '' ? <p className="connection-wizard-error" role="alert">{error}</p> : null}
      <div className="connection-wizard-actions">
        {connected ? (
          <button type="button" className="btn-secondary" disabled={isSubmitting} onClick={() => { void handleDisconnect(); }}>
            {isSubmitting ? __('Déconnexion...') : __('Déconnecter')}
          </button>
        ) : null}
      </div>
    </section>
  );
};

export default ComptExpertTokenWizard;
